export default __webpack_public_path__ + "static/media/moh_mihyar.8a79f8d0.jfif";